import { useParams } from "react-router-dom";

import { Box } from "@mui/material";

import { Layout } from "Layout";

import { ListPage } from "components/ListPage/ListPage";

import { i18n } from "services/i18nService";

import { useEditModal } from "hooks/useEditModal";
import { usePlans } from "hooks/usePlans";

import { Forbidden } from "Forbidden";

export function PlusList(props) {
  const { objectType } = props;
  const { id } = useParams();
  const { hasAtLeastPlusPlan } = usePlans();

  useEditModal(objectType, id, hasAtLeastPlusPlan);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      <Box sx={{ display: "flex", position: "relative" }}>
        {hasAtLeastPlusPlan ? (
          <ListPage objectType={objectType} />
        ) : (
          <Forbidden />
        )}
      </Box>
    </Layout>
  );
}
